// Very basic check for a small screen

import get from 'lodash/get'

export const EXTRA_SMALL_SCREEN_PIXELS = 375
export const SMALL_SCREEN_PIXELS = 450
export const MEDIUM_SCREEN_PIXELS = 600
export default function IsSmallScreen (comparePixels = EXTRA_SMALL_SCREEN_PIXELS) {
  const innerWidth = get(window, 'innerWidth', null)
  if (innerWidth && innerWidth <= comparePixels) {
    return true
  }
  const innerHeight = get(window, 'innerHeight', null)
  if (innerHeight && innerHeight <= comparePixels) {
    return true
  }
  return false
}
